
export const tableConfig = {
    name: 'customerComparison',
    height: 425,
    selection: false,
    columns: [
        {
            label: '变更项目',
            prop: 'updateFieldName',
            width: 180
        },
        {
            label: '变更前',
            prop: 'oldValueName'
        },
        {
            label: '变更后',
            prop: 'newValueName'
        },

        {
            label: '修改人',
            prop: 'updateUserName',
            width: 140

        },
        {
            label: '修改时间',
            prop: 'updateTime',
            width: 160
        }
    ]
};
